export enum SubscriptionCategory {
  'All',
  'Student',
  'School',
}
